export default __webpack_public_path__ + "static/media/sexology.43c66f47.svg";